import './sass/main.scss';
import { run } from './js/app';
import {
  elements,
  mqList,
  clearLoader,
  isNavVisible,
  lazyLoad,
} from './js/base';
import { collapseMainNav } from './js/mainNavigation';
// import { fadeHomeHeaderText } from './js/Home';
import { animateInView, highlightInView } from './js/animation';

window.onload = () => {
  elements.body.style.visibility = 'visible';

  if (document.querySelector('.loader')) {
    document.querySelector('.loader').style.opacity = 0;
    setTimeout(clearLoader, 700); // loader transition set to .7s
  }

  lazyLoad();
};

window.onresize = () => {
  collapseMainNav();
  animateInView();
  highlightInView();

  if (mqList.medLarge.matches) {
    elements.sectionNums.forEach((sectionNum) => {
      if (sectionNum.innerHTML === '&nbsp;') sectionNum.style.display = 'none';
    });
  }
};

window.onscroll = () => {
  collapseMainNav();
  animateInView();
  highlightInView();

  elements.navLogo.style.visibility =
    mqList.xlarge.matches && !isNavVisible() ? 'hidden' : 'visible';

  // if (elements.worksContainer) fadeHomeHeaderText();
};

run();
